/**
 * Created by lency on 9/23/2016.
 */
import template from './ybfooter.html';
import './ybfooter.scss';
import controller from './ybfooter.controller';

let footerComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default footerComponent;



// WEBPACK FOOTER //
// ./src/app/common/yb-small-footer/ybfooter.component.js